import React from "react";

import { Space } from "antd";

export const ColumnsCompanyCategory = [
  {
    title: "CNPJ",
    dataIndex: "clientDocument",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Cliente",
    dataIndex: "client",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Código",
    dataIndex: "code",
    width: "10%",
    ellipsis: true,
  },
  {
    title: "Categoria",
    dataIndex: "name",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Tipo",
    dataIndex: "typeCategoryString",
    textWrap: "word-break",
    width: "10%",
    ellipsis: true,
  },
  {
    title: "Classificação",
    dataIndex: "costTypeString",
    textWrap: "word-break",
    width: "10%",
    ellipsis: true,
  },
  {
    title: "Budget",
    dataIndex: "budgetString",
    ellipsis: true,
    width: "10%",
  },
  {
    title: "Ações",
    dataIndex: "action",
    render: (text, row) => {
      return (
        <Space size="middle">
          <a onClick={() => row.edit(row)} type="primary">
            Editar
          </a>
          <a onClick={() => row.disable(row)} type="primary">
            Desativar
          </a>
        </Space>
      );
    },
  },
];

export const ColumnsCompanyCategoryCsv = [
  {
    label: "CNPJ",
    key: "clientDocument",
  },
  {
    label: "Cliente",
    key: "client",
  },
  {
    label: "Código",
    key: "code",
  },
  {
    label: "Categoria",
    key: "name",
  },
  {
    label: "Tipo",
    key: "typeCategoryString",
  },
  {
    label: "Classificação",
    key: "costTypeString",
  },
  {
    label: "Budget",
    key: "budgetString",
  },
];
